
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import { AttributesRequest, Board, Card, CardAttribute, CardAttributeDefinition, CardAttributeDefinitionType, Ticket } from '../../backend/backendapi';
import { KanbanState } from '../kanban.model';
import VueFormAttribute from './attributes/modal/attribute/VueFormAttribute';
import { handleError } from '../../../api';
import Spinner from '../../util/Spinner';

@Component({
  components: {
    Spinner,
    VueFormAttribute,
  },
})
export default class VueFormIfSingularAttribute extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;
  @Prop({ required: true })
  readonly flow!: Ticket;
  @Prop({ required: true })
  readonly card!: Card;

  saving: boolean = false;

  get editableVueFormDefinition(): CardAttributeDefinition | undefined {
    if (this.board.attributeDefinitions?.length !== 1) {
      return undefined;
    }

    const def = this.board.attributeDefinitions[0];
    if (def.type === CardAttributeDefinitionType.Form && def.metaData?.length) {
      return def;
    }

    return undefined;
  }

  get hasOneEditableVueForm(): boolean {
    return !!this.editableVueFormDefinition;
  }

  get editableVueFormAttribute(): CardAttribute | undefined {
    if (!this.editableVueFormDefinition || !this.card)
      return undefined;

    this.card.attributes ??= [];
    let attr = this.card.attributes.find(e => e.definitionId === this.editableVueFormDefinition!.id);
    if (!attr) {
      attr = new CardAttribute({ id: 0, cardId: this.card.id!, definitionId: this.editableVueFormDefinition.id, value: '' });
      this.card.attributes.push(attr);
    }
    return attr;
  }

  async saveVueForm(): Promise<void> {
    if (!this.card || !this.editableVueFormAttribute) {
      return;
    }

    const request = new AttributesRequest({
      cardId: this.card.id!,
      attributes: [this.editableVueFormAttribute!],
    });

    this.saving = true;
    try {
      await this.state.cardsAPI.updateAttributes(request);
      this.$toasted.info(this.$t('txtSaved').toString());
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.saving = false;
    }
  }
}
